
import React, { useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import useMounted from '../../../hooks/useMounted';

import SimpleReactValidator from 'simple-react-validator';
import { post, get } from '../../../helpers/api_helper';
import { POST_GET_EMPLOYEE_DETAIL, POST_ADD_EDIT_EMPLOYEE, GET_OPTION } from '../../../helpers/url_helper';
import { toast } from 'react-toastify';
import Loader from '../../../components/Loader';
import { useTranslation } from 'react-i18next';

const Setting = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [isLoader, setLoader] = useState(0);
    const [units, setUnits] = useState([]);
    const [departments, setDepartments] = useState([]);

    const simpleValidator = useRef(new SimpleReactValidator());
    const [ButtonDisabled, SetButtonDisabled] = useState(false);
    const [form_inputs, setInputs] = useState({
        employeeId: 0,
        departmentId: '',
        unitId: '',
        employeeCode: '',
        name: '',
        mobileNumber: '',
        gender: '',
        address: '',
        email: '',
        contactPersonName: '',
        contactPersonMobileNumber: '',
        contactPersonRelation: '',
        bankName: '',
        accountNumber: '',
        ifscCode: '',
        salary: '',
        salaryType: '',
        workingHours: '',
        photo: '',
        aadhaarCardPhoto: '',
        photoBase64: '',
        aadhaarCardPhotoBase64: '',
    });
    const [, forceUpdate] = useState();

    const { id } = useParams()

    useMounted(() => {
        async function get_detaile() {
            const api_res = await get(GET_OPTION);
            if (api_res.status) {
                setUnits(api_res.data.units);
                setDepartments(api_res.data.departments);
            }

            if (id) {
                var res_data = await post(POST_GET_EMPLOYEE_DETAIL, { 'employeeId': id });
                if (res_data.status) {
                    setInputs(res_data.data.detail);
                } else {
                    toast.error(res_data.message);
                    navigate("/dashboard");
                }
            }
            setLoader(1)
        }

        get_detaile();
    }, [navigate])

    // form submit event
    const handleSubmit = async (event) => {
        event.preventDefault();
        const formValid = simpleValidator.current.allValid()
        if (!formValid) {
            simpleValidator.current.showMessages(true);
            forceUpdate(1);
        } else {
            SetButtonDisabled(true);
            var res_data = await post(POST_ADD_EDIT_EMPLOYEE, form_inputs);
            if (res_data.status) {
                toast(res_data.message);
                navigate("/employees");
            } else {
                toast.error(res_data.message);
            }
            SetButtonDisabled(false);
        }
    }

    const resizeImage = (file, maxWidth, maxHeight) => {
        return new Promise((resolve) => {
            const reader = new FileReader();

            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;

                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = maxWidth;
                    canvas.height = maxHeight;

                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0, maxWidth, maxHeight);

                    const compressedBase64 = canvas.toDataURL('image/jpeg', 0.8); // adjust quality if needed
                    resolve(compressedBase64);
                };
            };

            reader.readAsDataURL(file);
        });
    };


    // input text change handler
    const handleInputChange = async (event) => {
        event.persist();
        if (event.target.name === 'aadhaarCardPhotoBase64' || event.target.name === 'photoBase64') {
            const { files } = event.target;
            const file = files[0];
            if (!file) return;

            const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
            const maxSize = 5 * 1024 * 1024; // 5MB
            if (!allowedTypes.includes(file.type)) {
                toast.error('Only JPG, JPEG, PNG files are allowed.');
                return;
            }
            if (file.size > maxSize) {
                toast.error('File size must be less than 5MB.');
                return;
            }

            // Resize and convert to base64
            const base64Resized = await resizeImage(file, 500, 500);

            setInputs(inputs => ({ ...inputs, [event.target.name]: base64Resized }));

        } else {
            setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
        }
    }

    const amountFormat = (e) => {
        const value = e.target.value;
        const regex = /^\d*\.?\d*$/;
        if (!regex.test(value)) {
            // Remove invalid character if not matching
            e.target.value = value.slice(0, -1);
        }
    }

    const allowOnlyNumbers = (e) => {
        const value = e.target.value;
        const regex = /^\d*\.?\d*$/; // allow only digits and one dot

        // If invalid, remove the last entered character
        if (!regex.test(value)) {
            e.target.value = value.slice(0, -1); // remove last character
        }
    };

    if (!isLoader) {
        return (<Loader />);
    }
    return (
        <>
            <form className="av-invalid" onSubmit={handleSubmit}>
                <div className='row'>
                    <div className="col-md-6">
                        <div className="card mb-4">
                            <h5 className="card-header">{t('employee.form.personalInformation')}</h5>
                            <div className="card-body">
                                <div className='row'>
                                    <div className='col-sm-4 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.employeeCode')}</label>
                                        <input name="employeeCode" value={form_inputs.employeeCode} onChange={handleInputChange} className="form-control" placeholder={t('employee.placeholder.employeeCode')} type="text" />
                                    </div>
                                    <div className='col-sm-8 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.fullName')} *</label>
                                        <input name="name" value={form_inputs.name} onChange={handleInputChange} className="form-control" placeholder={t('employee.placeholder.fullName')} type="text" />
                                        {simpleValidator.current.message('name', form_inputs.name, 'required', {
                                            messages: {
                                                required: t('employee.formError.fullNameRequired')
                                            }
                                        })}
                                    </div>
                                    <div className='col-sm-4 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.gender')} *</label>
                                        <select name="gender" value={form_inputs.gender} onChange={handleInputChange} className="form-control">
                                            <option value="">{t('employee.placeholder.gender')}</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Other">Other</option>
                                        </select>
                                        {simpleValidator.current.message('gender', form_inputs.gender, 'required', {
                                            messages: {
                                                required: t('employee.formError.genderRequired')
                                            }
                                        })}
                                    </div>
                                    <div className='col-sm-8 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.mobileNumber')} *</label>
                                        <input name="mobileNumber" value={form_inputs.mobileNumber} onKeyUp={allowOnlyNumbers} onChange={handleInputChange} className="form-control" placeholder={t('employee.placeholder.mobileNumber')} type="text" maxLength={10} />
                                        {simpleValidator.current.message('mobileNumber', form_inputs.mobileNumber, 'required', {
                                            messages: {
                                                required: t('employee.formError.mobileNumberRequired'),
                                                numeric: t('employee.formError.mobileNumberNumeric'),
                                                min: t('employee.formError.mobileNumberMin'),
                                                max: t('employee.formError.mobileNumberMax'),
                                            }
                                        })}
                                    </div>
                                    <div className='col-sm-12 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.emailAddress')}</label>
                                        <input name="email" value={form_inputs.email} onChange={handleInputChange} className="form-control" placeholder={t('employee.placeholder.emailAddress')} type="text" />
                                        {simpleValidator.current.message('email', form_inputs.email, 'email', {
                                            messages: {
                                                email: t('employee.formError.emailAddressValid')
                                            }
                                        })}
                                    </div>
                                    <div className='col-sm-12 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.address')}</label>
                                        <textarea name="address" value={form_inputs.address} onChange={handleInputChange} className="form-control" placeholder={t('employee.placeholder.address')} />
                                    </div>
                                    <div className='col-sm-6 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.unit')}</label>
                                        <select name="unitId" value={form_inputs.unitId} onChange={handleInputChange} className="form-control">
                                            <option value="">{t('employee.placeholder.unit')}</option>
                                            {units && units.map((unit, key) => {
                                                return (<option value={unit.unitId}>{unit.unitName}</option>)
                                            })}
                                        </select>
                                    </div>
                                    <div className='col-sm-6 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.department')}</label>
                                        <select name="departmentId" value={form_inputs.departmentId} onChange={handleInputChange} className="form-control">
                                            <option value="">{t('employee.placeholder.department')}</option>
                                            {departments && departments.map((department, key) => {
                                                return (<option value={department.departmentId}>{department.departmentName}</option>)
                                            })}
                                        </select>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div className="card mb-4">
                            <h5 className="card-header">{t('employee.form.photoDocuments')}</h5>
                            <div className="card-body">
                                <div class="row">
                                    <div class="col-md-6 mb-3">
                                        <label className='mb-2'>{t('employee.form.employeePhoto')}</label>
                                        {(form_inputs.photoBase64 || form_inputs.photo) &&
                                            <div className='photo-upload-view'>
                                                <img src={(form_inputs.photoBase64) ? form_inputs.photoBase64 : form_inputs.photo} alt='employee photo' />
                                                <i class="fa fa-times remove" onClick={() => { form_inputs.photoBase64 = ''; form_inputs.photo = ''; setInputs({ ...form_inputs }) }} aria-hidden="true"></i>
                                            </div>
                                        }
                                        {(!form_inputs.photoBase64 && !form_inputs.photo) && <>
                                            <label class="photo-upload w-100" htmlFor='photoInput'>
                                                <i class="fa fa-camera"></i>
                                                <p class="mb-0">{t('employee.form.uploadInfo')}</p>
                                                <small class="text-muted">{t('employee.form.uploadFileSize')}</small>
                                            </label>
                                            <input type="file" name='photoBase64' onChange={handleInputChange} id="photoInput" class="d-none" accept="image/*" />
                                        </>}
                                    </div>
                                    <div class="col-md-6 mb-3">
                                        <label className='mb-2'>{t('employee.form.aadhaarCardPhoto')}</label>
                                        {(form_inputs.aadhaarCardPhotoBase64 || form_inputs.aadhaarCardPhoto) &&
                                            <div className='photo-upload-view'>
                                                <img src={(form_inputs.aadhaarCardPhotoBase64) ? form_inputs.aadhaarCardPhotoBase64 : form_inputs.aadhaarCardPhoto} alt='Aadhaar Card' />
                                                <i class="fa fa-times remove" onClick={() => { form_inputs.aadhaarCardPhotoBase64 = ''; form_inputs.aadhaarCardPhoto = ''; setInputs({ ...form_inputs }) }} aria-hidden="true"></i>
                                            </div>
                                        }
                                        {(!form_inputs.aadhaarCardPhotoBase64 && !form_inputs.aadhaarCardPhoto) && <>
                                            <label class="photo-upload w-100" htmlFor='aadhaarInput'>
                                                <i class="fa fa-id-card"></i>
                                                <p class="mb-0">{t('employee.form.uploadInfo')}</p>
                                                <small class="text-muted">{t('employee.form.uploadFileSize')}</small>
                                            </label>
                                            <input type="file" name='aadhaarCardPhotoBase64' onChange={handleInputChange} id="aadhaarInput" class="d-none" accept="image/*" />
                                        </>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="card mb-4">
                            <h5 className="card-header">{t('employee.form.emergencyContact')}</h5>
                            <div className="card-body">
                                <div className='row'>
                                    <div className='col-sm-6 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.contactPersonName')}</label>
                                        <input name="contactPersonName" value={form_inputs.contactPersonName} onChange={handleInputChange} className="form-control" placeholder={t('employee.placeholder.contactPersonName')} type="text" />
                                    </div>
                                    <div className='col-sm-6 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.relationship')}</label>
                                        <select name="contactPersonRelation" value={form_inputs.contactPersonRelation} onChange={handleInputChange} className="form-control" >
                                            <option value="">{t('employee.placeholder.relationship')}</option>
                                            <option value="Father">Father</option>
                                            <option value="Mother">Mother</option>
                                            <option value="Husband">Husband</option>
                                            <option value="Wife">Wife</option>
                                            <option value="Brother">Brother</option>
                                            <option value="Sister">Sister</option>
                                            <option value="Son">Son</option>
                                            <option value="Friend">Friend</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                    <div className='col-sm-6 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.contactMobile')}</label>
                                        <input name="contactPersonMobileNumber" value={form_inputs.contactPersonMobileNumber} onKeyUp={allowOnlyNumbers} onChange={handleInputChange} className="form-control" placeholder={t('employee.placeholder.mobileNumber')} type="text" maxLength={10} />
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="card mb-4">
                            <h5 className="card-header">{t('employee.form.bankInformation')}</h5>
                            <div className="card-body">
                                <div className='row'>
                                    <div className='col-sm-6 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.bankName')}</label>
                                        <input name="bankName" value={form_inputs.bankName} onChange={handleInputChange} className="form-control" placeholder={t('employee.placeholder.bankName')} type="text" />
                                    </div>
                                    <div className='col-sm-6 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.accountNumber')}</label>
                                        <input name="accountNumber" value={form_inputs.accountNumber} onKeyUp={allowOnlyNumbers} onChange={handleInputChange} className="form-control" placeholder={t('employee.placeholder.accountNumber')} type="text" />
                                    </div>
                                    <div className='col-sm-6 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.IFSCCode')}</label>
                                        <input name="ifscCode" value={form_inputs.ifscCode} onChange={handleInputChange} className="form-control" placeholder={t('employee.placeholder.IFSCCode')} type="text" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card mb-4">
                            <h5 className="card-header">{t('employee.form.salaryInformation')}</h5>
                            <div className="card-body">
                                <div className='row'>
                                    <div className='col-sm-6 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.salaryAmount')} *</label>
                                        <input name="salary" value={form_inputs.salary} onKeyUp={amountFormat} onChange={handleInputChange} className="form-control" placeholder={t('employee.placeholder.salaryAmount')} type="text" />
                                        {simpleValidator.current.message('amount', form_inputs.salary, 'required', {
                                            messages: {
                                                required: t('employee.formError.salaryAmountRequired')
                                            }
                                        })}
                                    </div>
                                    <div className='col-sm-6 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.salaryType')} *</label>
                                        <select name="salaryType" value={form_inputs.salaryType} onChange={handleInputChange} className="form-control">
                                            <option value="">{t('employee.placeholder.salaryType')}</option>
                                            <option value="Per Month">Per Month</option>
                                            <option value="Per Day">Per Day</option>
                                            <option value="Per Hour">Per Hour</option>
                                        </select>
                                        {simpleValidator.current.message('type', form_inputs.salaryType, 'required', {
                                            messages: {
                                                required: t('employee.formError.salaryTypeRequired')
                                            }
                                        })}
                                    </div>
                                    <div className='col-sm-6 mb-3'>
                                        <label className="form-label text-capitalize">{t('employee.form.workingHours')} *</label>
                                        <input name="workingHours" value={form_inputs.workingHours} onKeyUp={allowOnlyNumbers} onChange={handleInputChange} className="form-control" placeholder={t('employee.placeholder.workingHours')} type="text" maxLength={2} />
                                        {simpleValidator.current.message('workingHours', form_inputs.workingHours, 'required', {
                                            messages: {
                                                required: t('employee.formError.workingHoursRequired')
                                            }
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card mb-4">
                    <div className="card-body">
                        <div className='text-center'>
                            <button disabled={ButtonDisabled} className="btn btn-primary pt-2 pb-2">
                                {ButtonDisabled && <i className="fa fa-spinner me-2 fa-spin"></i>} {t('save')}
                            </button>
                            <Link to="/employees" className="btn btn-danger ms-3"> {t('cancel')}</Link>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
}

export default Setting;